import { render, staticRenderFns } from "./MoreTableButton.vue?vue&type=template&id=447c6c9c&"
import script from "./MoreTableButton.vue?vue&type=script&lang=js&"
export * from "./MoreTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports